export const INDICES_VIEW_ALL = "INDICES_VIEW_ALLINDICES";
export const INDICES_VIEW_ALL_ERROR = "INDICES_VIEW_ALL_ERROR";
export const INDICES_VIEW_ALL_HIDE_ERROR = "INDICES_VIEW_ALL_HIDE_ERROR";
export const INDICES_VIEW_ALL_START_LOADER = "INDICES_VIEW_ALL_START_LOADER";
export const INDICES_VIEW_ALL_STOP_LOADER = "INDICES_VIEW_ALL_STOP_LOADER";
export const INDICES_VIEW_ALL_STREAM = "INDICES_VIEW_ALL_STREAM";
